import React, { useEffect, useState } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

const SimpleCircularTimer = ({ auctionDate }) => {
  const [duration, setDuration] = useState(0);
  const [key, setKey] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (!auctionDate) return;

    const now = new Date();
    const auctionTime = new Date(auctionDate);
    const diffInSeconds = Math.floor((auctionTime - now) / 1000);

    if (diffInSeconds > 0) {
      setDuration(diffInSeconds);
      setKey((prev) => prev + 1);
      setIsPlaying(true);
    } else {
      setDuration(0);
      setIsPlaying(false);
    }
  }, [auctionDate]);

  return (
    <div className="relative flex justify-center items-center">
      <CountdownCircleTimer
        key={key}
        isPlaying={isPlaying}
        duration={duration}
        size={150}
        strokeWidth={10}
        colors={["#10B981", "#F59E0B", "#EF4444"]}
        colorsTime={[duration * 0.6, duration * 0.3, 0]}
        // onComplete={() => {
        //   window.location.reload(); // ✅ Only called once
        //   return { shouldRepeat: false };
        // }}
        onComplete={() => {
          const cleanUrl = window.location.origin + "/live-auction-portal";
          window.location.href = cleanUrl;
          return { shouldRepeat: false };
        }}
      >
        {({ remainingTime }) => {
          const days = Math.floor(remainingTime / 86400); // seconds in a day
          const hours = Math.floor((remainingTime % 86400) / 3600);
          const minutes = Math.floor((remainingTime % 3600) / 60);
          const seconds = remainingTime % 60;
          return (
            <div className="text-[14px] lg:text-[20px] font-semibold text-green-600 text-center">
              {remainingTime <= 0 ? (
          "Auction Started"
        ) : days > 0 ? (
          `${days}d ${hours}h ${minutes}m`
        ) : hours > 0 ? (
          `${hours}h ${minutes}m ${seconds}s`
        ) : (
          `${minutes}m ${seconds}s`
        )}
            </div>
          );
        }}
      </CountdownCircleTimer>
    </div>
  );
};

export default SimpleCircularTimer;
